import { Dialog } from "@material-ui/core";
import {
  FormTitle,
  InfoArea,
  StyledPaper,
} from "components/addProjectRemarkPopup/styles";
import { FunctionalButton } from "components/functionalButton";
import { CloseButton } from "components/closeButton";
import PylonIcon from "assets/common/pylonIcon.png";
import { SmallTitleText } from "components/addPaymentProgressContractorPopup/styles";

type DeleteDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DeletePopup = ({
  open,
  onConfirm,
  onCancel,
}: DeleteDialogProps) => {
  return (
    <Dialog open={open}>
      <StyledPaper elevation={0} style={{ width: "600px" }}>
        <CloseButton handleClose={onCancel} />
        <img src={PylonIcon} />
        <FormTitle
          style={{
            marginTop: "30px",
            marginBottom: "20px",
            color: "#1A051D",
            fontSize: "22px",
            fontWeight: 600,
            fontStyle: "normal",
            lineHeight: "24px",
          }}
        >
          Confirm Deletion
        </FormTitle>
        <SmallTitleText>
          Are you sure you want to delete this IDP document? This action is
          irreversible.
        </SmallTitleText>
        <InfoArea>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: "16px",
              paddingBottom: "40px",
            }}
          >
            <div style={{ width: "250px" }}>
              <FunctionalButton
                buttonTitle="Cancel"
                handleButton={onCancel}
                width={250}
                height={undefined}
                isReversedColor={true}
                marginRight={undefined}
                marginLeft={undefined}
                marginTop={undefined}
                marginBottom={undefined}
                fontSize={undefined}
                disabled={undefined}
                icon={undefined}
                hasBoxShadow={undefined}
                frontIcon={undefined}
                weight={undefined}
                borderColor={undefined}
                selected={undefined}
              />
            </div>
            <div style={{ width: "250px" }}>
              <FunctionalButton
                buttonTitle="Confirm"
                handleButton={onConfirm}
                width={250}
                height={undefined}
                isReversedColor={undefined}
                marginRight={undefined}
                marginLeft={undefined}
                marginTop={undefined}
                marginBottom={undefined}
                fontSize={undefined}
                disabled={undefined}
                icon={undefined}
                hasBoxShadow={undefined}
                frontIcon={undefined}
                weight={undefined}
                borderColor={undefined}
                selected={undefined}
              />
            </div>
          </div>
        </InfoArea>
      </StyledPaper>
    </Dialog>
  );
};
